module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin_cyrillic-700.e190db96.svg";